import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { Avatar, Typography } from "@shared/ui";
import { UserCircle2 } from "lucide-react";
import styles from "../styles.module.scss";

const { Text } = Typography;

interface PocWorkloadListProps {
  workloads: IPricingWorkload[];
  selectedSpocId: string;
  onSelect: (spocId: string) => void;
  briefPocUserIds?: string[];
  defaultPricingPocId?: string;
  defaultAgencyPricingPocId?: string;
}

export function PocWorkloadList({
  defaultPricingPocId,
  defaultAgencyPricingPocId,
  workloads,
  selectedSpocId,
  onSelect,
  briefPocUserIds = [],
}: PocWorkloadListProps) {
  if (!workloads.length) {
    return (
      <div className={styles.pocCardEmpty}>
        <Text type="secondary">
          {briefPocUserIds.length
            ? "No employees match your search."
            : "No pricing POCs available. Try a different search."}
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.pocList}>
      {workloads.map((w) => {
        const selected = w.user._id === selectedSpocId;
        const isOnBrief = briefPocUserIds.includes(w.user._id);
        const fullName =
          `${w.user.firstName ?? ""} ${w.user.lastName ?? ""}`.trim();

        return (
          <button
            key={w.user._id}
            type="button"
            onClick={() => onSelect(w.user._id)}
            className={`${styles.pocCard} ${
              selected ? styles.pocCardSelected : ""
            }`}
          >
            <div className={styles.pocCardLeft}>
              {w.user.profilePicUrl ? (
                <Avatar size={32} src={w.user.profilePicUrl} />
              ) : (
                <UserCircle2
                  size={28}
                  className={
                    selected ? styles.pocCardIconSelected : styles.pocCardIcon
                  }
                />
              )}
              <div className={styles.pocCardInfo}>
                <div className={styles.pocCardNameRow}>
                  <span className={styles.pocCardName}>{fullName || "—"}</span>
                  {isOnBrief ? (
                    <span className={styles.pocCardBadge}>On brief</span>
                  ) : null}
                  {defaultPricingPocId === w.user._id ? (
                    <span className={styles.pocCardBadge}>Default POC</span>
                  ) : null}
                  {defaultAgencyPricingPocId === w.user._id ? (
                    <span className={styles.pocCardBadgeAgency}>
                      Default agency POC
                    </span>
                  ) : null}
                </div>
                <div className={styles.pocCardEmail}>{w.user.emailId}</div>
              </div>
            </div>
            <div className={styles.pocCardRight}>
              <div className={styles.pocCardPending}>
                {w.activeBriefInfluencersPendingCount} pending
              </div>
              <div className={styles.pocCardMeta}>
                {w.activeBriefInfluencersAllocatedCount} allocated ·{" "}
                {w.activeBriefInfluencersPricedCount} priced
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
